import { request } from '@umijs/max';
import { config } from '@/utils/config';
import qs from 'qs';

/**
 * 
 * @param data 登录
 * @returns 
 */
export const ToLogin = async (data?: any) => {
  return request('/LoginApi/community/login', {
    method: 'POST',
    data: data,
    headers: {
      Authorization: '',
    },
  });
};

/**
 * 退出
 */
export const logout = async (data?: any) => {
  return request('/api/community/logout', {
    method: 'POST',
    data: data
  });
};
/**
 * 注册
 * @param data 
 * @returns 
 */
export const register = async (data?: any) => {
  return request('/LoginApi/community/owner/WechatOwner/register', {
    method: 'POST',
    data: data,
    headers: {
      Authorization: '',
    },
  });
};


/**
 * 修改密码
 * @param data 
 * @returns 
 */
export const updatePwd = async (data?: any) => {
  return request('/LoginApi/community/owner/WechatOwner/updatePwd', {
    method: 'POST',
    data: data,
    headers: {
      Authorization: '',
    },
  });
};